/* @ngInject */
export default function TeamWorkspaceBaseController(TeamWorkspaceManager) {
  const vm = this;

  vm.TeamWorkspaceManager = TeamWorkspaceManager;
}
